import { useState, useCallback } from 'react';

interface ApiError {
  status: number;
  message: string;
  isUnauthorized: boolean;
}

interface UseApiErrorHandlerReturn {
  error: ApiError | null;
  setError: (error: ApiError | null) => void;
  clearError: () => void;
  handleApiError: (error: any) => void;
  isUnauthorized: boolean;
}

export const useApiErrorHandler = (): UseApiErrorHandlerReturn => {
  const [error, setError] = useState<ApiError | null>(null);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const handleApiError = useCallback((error: any) => {
    let apiError: ApiError;

    if (error?.status) {
      // Fetch API error response or custom error with status
      apiError = {
        status: error.status,
        message: error.message || error.statusText || `HTTP ${error.status} Error`,
        isUnauthorized: error.status === 403
      };
    } else if (error?.message) {
      // Generic error object
      apiError = {
        status: 0,
        message: error.message,
        isUnauthorized: false
      };
    } else {
      // Unknown error
      apiError = {
        status: 0,
        message: 'An unexpected error occurred',
        isUnauthorized: false
      };
    }

    setError(apiError);
  }, []);

  return {
    error,
    setError,
    clearError,
    handleApiError,
    isUnauthorized: error?.isUnauthorized || false
  };
};
